import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Pagamento, Renovacao } from "./pages";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/pagamento?cart=Q0Y6Qzow" />} />
        <Route path="/pagamento" element={<Pagamento />} />
        <Route path="/renovacao" element={<Renovacao />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
